import { Tabs } from '@common/ui'
import { useLocation, useNavigate } from 'react-router-dom'

type TabValue = 'grants' | 'policies'

const AccessControlTabs = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const value: TabValue = location.pathname.startsWith('/access-control/policies') ? 'policies' : 'grants'

  return (
    <Tabs
      value={value}
      onChange={(next) => navigate(next === 'grants' ? '/access-control' : '/access-control/policies')}
      px="md"
    >
      <Tabs.List>
        <Tabs.Tab value="grants">Grants</Tabs.Tab>
        <Tabs.Tab value="policies">Policies</Tabs.Tab>
      </Tabs.List>
    </Tabs>
  )
}

export default AccessControlTabs
